<template>
  <div :class="{style2: $route.query.s == 2}">
    <div class="header">
      <div class="clock">{{clock}}</div>
      <div class="stop-name">{{panelConfig.panelHeader}}</div>
    </div>
    <DeparturesTableFlorianopolis :panelConfig="panelConfig" :stopData="stopData"></DeparturesTableFlorianopolis>
  </div>
</template>

<script>
import DeparturesTableFlorianopolis from './DeparturesTableFlorianopolis';

export default {
  components: {
    DeparturesTableFlorianopolis
  },
  props: ['panelConfig', 'stopData', 'clock'],
  watch: {
    stopData: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.convertTrips();
      }
    }
  },
  methods: {
    convertTrips() {
      let trips = [];

      // transform trips with multi times to a list of trips with single time
      this.stopData.trips.forEach(trip => {
        trip.times.forEach(time => {
          const newTrip = { ...trip };
          newTrip.times = [time];
          newTrip.key = newTrip.tripId + '@' + time.time;
          trips.push(newTrip);
        });
      });

      if (this.$route.query.s == 2) {
        trips = trips.filter(t => t.times[0].vehicleId);
      }

      trips.sort((a, b) => {
        const t1 = a.times[0];
        const t2 = b.times[0];
        const ts1 = (t1.nextDay ? 1 : 0) + t1.time;
        const ts2 = (t2.nextDay ? 1 : 0) + t2.time;
        return ts1.localeCompare(ts2);
      });

      this.stopData.trips = trips;
    }
  },
  created() {
    this.convertTrips();
  }
};
</script>

<style lang="scss" scoped>
.header {
  padding: .4em .6em;
  font-weight: bold;
  background-color: #2f4a93;
  color: #fff;
}
.clock {
  float: right;
}
@media only screen and (min-width: 600px) {
  .clock {
    font-size: 1.4em;
    margin-top: -.26em;
  }
}
.style2 {
  .header {
    background-color: #8b6700;
  }
}
</style>

<style lang="scss">
.page-container {
  font-size: 4.5vw !important;
}
@media only screen and (min-width: 600px) {
  .sub.vehicle {
    font-size: .45em;
    margin: -.65em 1.6em;
  }
}
@media only screen and (min-width: 1400px) {
  .page-container {
    font-size: 2.8vw !important;
  }
  .headsign {
    max-width: 76vw !important;
  }
}

table tr th {
  background: transparent !important;
  background-color: #587cb7 !important;
}
.style2 {
  table tr th {
    background: transparent;
    background-color: #bf942d  !important;
  }
}
</style>